import { FC, useState } from 'react';
import { useContext } from 'react';
import { LanguageContext } from '../../../components/LanguageProvider';

interface link{
    linkNameEng: string;
    linkNamePl: string;
    link: string;
}

interface ProjectCard{
    projectName: string;
    projectImage: string;
    projectDescriptionEng: string;
    projectDescriptionPl: string;
    technologies: string[];
    links:link[]
}

export const ProjectCard:FC<ProjectCard> = ({projectName, projectImage, projectDescriptionEng, projectDescriptionPl, technologies, links }) => {

    const {polish} = useContext(LanguageContext)
    const [loaded, setLoaded] = useState(false)


    return ( 
        <div className="project-card w-full lg:min-h-32 md:min-h-96 mb-2 md:mb-4 bg-silver text-white relative">
            <a href={links[0].link}>
            <figure className='flex flex-col-reverse lg:flex-row justify-between items-center p-4 pb-0 md:p-6 gap-8'>
                <div className='w-full self-start'>
                    <figcaption className='md:text-center text-[1rem] md:text-2xl mb-2 md:mb-8'>{projectName}</figcaption>
                    <div className='project-details mr-2 mb-12 lg:mb-0'>
                        {!polish && <p className='mb-4 text-sm md:text-lg font-light md:font-normal'>{projectDescriptionEng}</p>}
                        {polish && <p className='mb-4 text-sm md:text-lg font-light md:font-normal'>{projectDescriptionPl}</p>}

                        {!polish && <p className='hidden md:block mb-2'>Technologies I used:</p>}
                        {polish &&<p className='hidden md:block mb-2'>Technologie:</p>}

                        <ul className='hidden md:block'>
                            {technologies.map((technology, number)=> (
                                <li key={number} className='font-light'>{technology}</li>
                                ))
                            }    
                            
                        </ul>
                    </div>
                    
                </div>
                {!loaded && <div role="status" className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
                    <div className="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-96 dark:bg-gray-700">
                        <svg className="w-12 h-12 text-gray-200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 640 512"><path d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z"/></svg>
                    </div>
                </div>
                }
               <img src={projectImage} onLoad={()=>setLoaded(true)} alt={projectName} className={loaded ? 'flex w-full lg:w-[40%] h-full' : 'hidden'}/>
            </figure>

            <div className='w-full'>
                        {!polish && 
                        <div className='text-yellow-orange font-light flex lg:w-full underline justify-start lg:justify-start gap-3 lg:gap-12 px-4 lg:px-6 min-h-12'>
                            {links.map((link, number)=> (
                                <div key={number} className='mb-2 text-left text-[0.8rem] md:text-[1rem]'><a href={link.link}>{link.linkNameEng}</a></div>
                            )
                            )}
                        </div>
                        }

                        {polish && 
                        <div className='text-yellow-orange font-light flex lg:w-full underline justify-start lg:justify-start gap-2 lg:gap-12 mx-1 px-4 lg:px-6 min-h-12'>
                            {links.map((link, number)=> (
                                <div key={number} className='text-center mb-2 md:text-left text-[0.9rem] md:text-[1rem]'><a href={link.link}>{link.linkNamePl}</a></div>
                            )
                         )}
                     </div>
                        }
                    </div>
            </a>
          
        </div>
     );
}
 
